// import { SplideSlide } from '@splidejs/react-splide'
// import { useParams } from 'react-router'
// import { Link } from 'react-router-dom'
// import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider'
// import SilderSponsersBanners from '../../../core/components/SilderSponsersBanners'

// export default function SliderDiamondSponsorsBanners() {
//   const { lng } = useParams()
//   const { sponsorTypesState } = useSponsorTypesContext()

//   if (sponsorTypesState.isLoading) {
//     return (
//       <div
//         data-aos="fade-up"
//         className="app-container"
//       >
//         <div className="h-[276px] animate-pulse bg-muted-400"></div>
//       </div>
//     )
//   }

//   if (sponsorTypesState.types.diamond?.have_sponsors)
//     return (
//       <SilderSponsersBanners>
//         {sponsorTypesState.types.diamond?.sponsors.map((sponsor) => (
//           <SplideSlide key={sponsor.id}>
//             <Link
//               to={`/${lng}/sponsors/${sponsor.slug}`}
//               className="flex flex-col items-start justify-start"
//             >
//               <div
//                 title={sponsorTypesState.types.diamond[`name_${lng}`]}
//                 className="max-h-[276px] overflow-hidden border-2 border-info bg-muted-300"
//               >
//                 <img
//                   src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.banner}`}
//                   alt={sponsor[`name_${lng}`]}
//                   className="h-full w-full object-contain"
//                 />
//               </div>
//             </Link>
//           </SplideSlide>
//         ))}
//       </SilderSponsersBanners>
//     )
// }





// import { SplideSlide } from '@splidejs/react-splide';
// import { useParams } from 'react-router';
// import { Link } from 'react-router-dom';
// import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider';
// import SilderSponsersBanners from '../../../core/components/SilderSponsersBanners';

// export default function SliderDiamondSponsorsBanners() {
//   const { lng } = useParams();
//   const { sponsorTypesState } = useSponsorTypesContext();

//   // Loading state
//   if (sponsorTypesState.isLoading) {
//     return (
//       <div data-aos="fade-up" className="app-container">
//         <div className="h-[276px] animate-pulse bg-muted-400"></div>
//       </div>
//     );
//   }

//   // Extraction sécurisée
//   const types = sponsorTypesState.types;
//   const diamond = types?.diamond;

//   // Si aucun sponsor ou diamond null → ne rien afficher
//   if (!diamond?.have_sponsors || !diamond.sponsors?.length) {
//     return null; // ou un message : <p>Aucun sponsor</p>
//   }

//   return (
//     <>
//     <SilderSponsersBanners>
//       {diamond.sponsors.map((sponsor) => (
//         <SplideSlide key={sponsor.id}>
//           <Link
//             to={`/${lng}/sponsors/${sponsor.slug}`}
//             className="flex flex-col items-start justify-start"
//           >
//             <div
//               title={diamond[`name_${lng}`]}
//               className="max-h-[276px] overflow-hidden border-2 border-info bg-muted-300"
//             >
//               <img
//                 src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.banner}`}
//                 alt={sponsor[`name_${lng}`]}
//                 className="h-full w-full object-contain"
//               />
//             </div>
//           </Link>
//         </SplideSlide>
//       ))}
      
//     </SilderSponsersBanners>
//      <SplideSlide>
//           <Link
//             to="
// https://aidsmo.org/aidmo-mining-events/365-mining-events-2026/1947-%D8%A7%D9%84%D9%85%D9%84%D8%AA%D9%82%D9%8A-%D9%88%D8%A7%D9%84%D9%85%D8%B9%D8%B1%D8%B6-%D8%A7%D9%84%D8%AF%D9%88%D9%84%D9%8A-%D9%84%D8%A7%D9%82%D8%AA%D8%B5%D8%A7%D8%AF%D9%8A%D8%A7%D8%AA-%D8%A7%D9%84%D9%85%D9%86%D8%A7%D8%AC%D9%85-%D9%88%D8%A7%D9%84%D9%85%D8%AD%D8%A7%D8%AC%D8%B1-%D8%A8%D8%A7%D9%84%D9%88%D8%B7%D9%86-%D8%A7%D9%84%D8%B9%D8%B1%D8%A8%D9%8A-2026.html"
//             className="flex flex-col items-start justify-start"
//           >
//             <div
//               className="max-h-[276px] overflow-hidden border-2 border-info bg-muted-300"
//             >
//               <img
//                 src={`/assets/gifs/platform-message.gif`}
//                 alt=""
//                 className="h-full w-full object-contain"
//               />
//             </div>
//           </Link>
//           </SplideSlide>
//     </>
//   );
// }














// import { SplideSlide } from '@splidejs/react-splide';
// import { useParams } from 'react-router';
// import { Link } from 'react-router-dom';
// import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider';
// import SilderSponsersBanners from '../../../core/components/SilderSponsersBanners';

// export default function SliderDiamondSponsorsBanners() {
//   const { lng } = useParams();
//   const { sponsorTypesState } = useSponsorTypesContext();

//   // Loading state
//   if (sponsorTypesState.isLoading) {
//     return (
//       <div data-aos="fade-up" className="app-container">
//         <div className="h-[276px] animate-pulse bg-muted-400"></div>
//       </div>
//     );
//   }

//   const types = sponsorTypesState.types;
//   const diamond = types?.diamond;

//   if (!diamond?.have_sponsors || !diamond.sponsors?.length) {
//     return null;
//   }

//   return (
//     <SilderSponsersBanners>
      
//       {/* Sponsors dynamiques */}
//       {diamond.sponsors.map((sponsor) => (
//         <SplideSlide key={sponsor.id}>
//           <Link
//             to={`/${lng}/sponsors/${sponsor.slug}`}
//             className="flex flex-col"
//           >
//             <div className="max-h-[276px] overflow-hidden border-2 border-info bg-muted-300">
//               <img
//                 src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.banner}`}
//                 alt={sponsor[`name_${lng}`]}
//                 className="h-full w-full object-contain"
//               />
//             </div>
//           </Link>
//         </SplideSlide>
//       ))}

//       {/* Slide statique */}
//       <SplideSlide>
//         <a
//           href="https://aidsmo.org/aidmo-mining-events/365-mining-events-2026/1947-%D8%A7%D9%84%D9%85%D9%84%D8%AA%D9%82%D9%8A-%D9%88%D8%A7%D9%84%D9%85%D8%B9%D8%B1%D8%B6-%D8%A7%D9%84%D8%AF%D9%88%D9%84%D9%8A-%D9%84%D8%A7%D9%82%D8%AA%D8%B5%D8%A7%D8%AF%D9%8A%D8%A7%D8%AA-%D8%A7%D9%84%D9%85%D9%86%D8%A7%D8%AC%D9%85-%D9%88%D8%A7%D9%84%D9%85%D8%AD%D8%A7%D8%AC%D8%B1-%D8%A8%D8%A7%D9%84%D9%88%D8%B7%D9%86-%D8%A7%D9%84%D8%B9%D8%B1%D8%A8%D9%8A-2026.html"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="flex flex-col"
//         >
//           <div className="max-h-[276px] overflow-hidden border-2 border-info bg-muted-300">
//             <img
//               src="/assets/gifs/platform-message.gif"
//               alt="event"
//               className="h-full w-full object-contain"
//             />
//           </div>
//         </a>
//       </SplideSlide>

//     </SilderSponsersBanners>
//   );
// }














import { SplideSlide } from '@splidejs/react-splide';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider';
import SilderSponsersBanners from '../../../core/components/SilderSponsersBanners';
import { sponsorAssetUrl } from '../../data/staticSponsors';

export default function SliderDiamondSponsorsBanners() {
  const { lng } = useParams();
  const { sponsorTypesState } = useSponsorTypesContext();

  // Loading
  if (sponsorTypesState.isLoading) {
    return (
      <div data-aos="fade-up" className="app-container">
        <div className="h-[276px] animate-pulse bg-muted-400"></div>
      </div>
    );
  }

  // Data
  const types = sponsorTypesState.types;
  const diamond = types?.diamond;

  // Si pas de sponsors
  if (!diamond?.have_sponsors || !diamond.sponsors?.length) {
    return null;
  }

  return (
    <div className="app-container" data-aos="fade-up">
      
      {/* ================= SLIDER ================= */}
      <SilderSponsersBanners>
        {diamond.sponsors.map((sponsor) => (
          <SplideSlide key={sponsor.id} data-splide-interval={sponsor.banner_type === 'video' ? 6000 : undefined}>
            <Link
              to={sponsor.banner_url ?? `/${lng}/sponsors/${sponsor.slug}`}
              target={sponsor.banner_url ? '_blank' : undefined}
              rel={sponsor.banner_url ? 'noopener noreferrer' : undefined}
              className="block"
              aria-label={sponsor[`name_${lng}`]}
            >
              <div className="h-[280px] overflow-hidden border-2 border-info bg-muted-300">
                {sponsor.banner_type === 'video' ? (
                  <video
                    src={sponsorAssetUrl(sponsor, 'banner')}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    aria-label={sponsor[`name_${lng}`]}
                    className="h-full w-full object-contain"
                  />
                ) : (
                  <img
                    src={sponsorAssetUrl(sponsor, 'banner')}
                    alt={sponsor[`name_${lng}`]}
                    className="h-full w-full object-contain"
                  />
                )}
              </div>
            </Link>
          </SplideSlide>
        ))}
      </SilderSponsersBanners>

      {/* ================= IMAGE STATIQUE ================= */}
      {/* <div className="mt-8">
        <a
          href="https://aidsmo.org/aidmo-mining-events/365-mining-events-2026/1947-%D8%A7%D9%84%D9%85%D9%84%D8%AA%D9%82%D9%8A-%D9%88%D8%A7%D9%84%D9%85%D8%B9%D8%B1%D8%B6-%D8%A7%D9%84%D8%AF%D9%88%D9%84%D9%8A-%D9%84%D8%A7%D9%82%D8%AA%D8%B5%D8%A7%D8%AF%D9%8A%D8%A7%D8%AA-%D8%A7%D9%84%D9%85%D9%86%D8%A7%D8%AC%D9%85-%D9%88%D8%A7%D9%84%D9%85%D8%AD%D8%A7%D8%AC%D8%B1-%D8%A8%D8%A7%D9%84%D9%88%D8%B7%D9%86-%D8%A7%D9%84%D8%B9%D8%B1%D8%A8%D9%8A-2026.html"
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >

          <div className="h-[280px] overflow-hidden border-2 border-info bg-muted-300">
            <img
              src="/assets/apip.png"
              alt="event"
              className="h-full w-full object-contain"
            />
          </div>

        </a>
      </div> */}

    </div>
  );
}












